import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7f6c47ed&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=7f6c47ed&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6c47ed",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Coupons: require('/app/components/coupons/coupons.vue').default})
